export default __webpack_public_path__ + "static/05june-44264c0894d0e6e9ee8c9cb4e6db0cb6.png";